import { jsx as _jsx } from "react/jsx-runtime";
import { CardHeader as MuiCardHeader, } from '@mui/material';
import { styled } from '../../../utils';
const getPadding = (theme, breakpoint) => {
    if (breakpoint === 'md') {
        return theme.spacing(2.5, 2.5, 2);
    }
    return theme.spacing(2, 2, 1);
};
const getTitleSize = (titleSize, theme) => {
    switch (titleSize) {
        case 'smallTitle':
            return theme.typography.subtitle2;
        case 'defaultTitle':
            return theme.typography.subtitle1;
        case 'largeTitle':
            return theme.typography.h3;
        default:
            return theme.typography.h3;
    }
};
const CardHeaderStyled = styled(MuiCardHeader, {
    shouldForwardProp: (prop) => prop !== 'avatarWidth' &&
        prop !== 'hideAvatarDownBreakpoint' &&
        prop !== 'titleSize',
})(({ theme, avatarWidth, hideAvatarDownBreakpoint, titleSize }) => ({
    '&.MuiCardHeader-root': {
        padding: getPadding(theme),
        [theme.breakpoints.up('md')]: {
            padding: getPadding(theme, 'md'),
        },
    },
    '&	.MuiCardHeader-action': { alignSelf: 'center', margin: 0 },
    '&	.MuiCardHeader-subheader': {
        color: theme.palette.secondary.dark,
        [theme.breakpoints.up('md')]: {
            fontSize: '1.125rem',
        },
    },
    '&	.MuiCardHeader-avatar': {
        color: theme.palette.primary.dark,
        flex: `0 0 ${avatarWidth}px`,
        '& >:first-of-type': {
            flex: '1 0 auto',
        },
        textAlign: 'center',
        ...(hideAvatarDownBreakpoint && {
            [theme.breakpoints.down(hideAvatarDownBreakpoint)]: {
                display: 'none',
            },
        }),
    },
    '&	.MuiCardHeader-title': {
        ...getTitleSize(titleSize, theme),
        ...(titleSize === 'smallTitle'
            ? { color: theme.palette.primary.main, fontWeight: 'bold' }
            : {}),
    },
}));
export function CardHeader(props) {
    const { titleSize = 'defaultTitle', avatarWidth = 45, ...otherProps } = props;
    return (_jsx(CardHeaderStyled, { titleSize: titleSize, avatarWidth: avatarWidth, ...otherProps }));
}
